import { sampling } from '@/components/Reports/Sidebar/Form/forms/SamplingGKZ/store';

/*
    * Описание параметров:
        -- Geo_Stratums_Priority
*/

/*
    Функция возвращает ключи stratums в порядке согласно дереву.
*/
function getOrderedStratumsKeys(versions, triplets) {
    const result = [];
    let idx = 0;

    for (const version of versions) {
        if (!version.children) {
            continue;
        }

        version.children.forEach(stratum => {
            if (triplets.includes(stratum.key)) {
                result.push(`${stratum.key}-${idx}`);
            }
        });

        idx += 1;
    }

    return result;
}

export const settingsGKZParams = params => {
    const { stratumsTriplets } = params;
    /*
        Данные хранятся в valtio store. Нам нужны эти данные, так как у них всегда будет верный порядок элементов.
    */
    const versions = sampling.store.data;

    return {
        Geo_Stratums_Priority: getOrderedStratumsKeys(versions, stratumsTriplets).join(','),
    };
};
